<template>
  <div class="my-booklib-container">
    <ListHeader class="books-list-header" listTitle="我的链接作品" @query-list="getBooks"></ListHeader>
    <LinksPublished ref="LinksPublished" :shelfLinkData="linkData" @changePage="changePage"></LinksPublished>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ListHeader from '@components/list/listHeader'
import LinksPublished from './components/LinksPublished'
import LinkPubilshen from '@api/LinkPubilshen'

export default {
  name: 'MyLinkword',
  data() {
    return {
      linkData: {
        userType: '我的链接作品',
        dataList: [], //图书馆列表信息
        totalCount: null //图书馆列表总数
      },
      title: '',
      searchData: {
        queryTitle: '',
        createTimeEnd: '',
        createTimeStart: ''
      }
    }
  },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    userName() {
      return localStorage.getItem('username')
    }
  },
  created() {
    this.getLinkList(1)
  },
  methods: {
    // 获取作品链接列表
    getLinkList(pageNo) {
      // pageNo页号 pageSize每页记录数
      let param = {
        pageNo: pageNo,
        pageSize: 11,
        username: this.booksCurrentSubAccount !== '' ? this.booksCurrentSubAccount : this.userName,
        title: this.searchData.queryTitle,
        createTimeStart: this.searchData.createTimeStart,
        createTimeEnd: this.searchData.createTimeEnd
      }
      LinkPubilshen.getLinkWorks(param).then((res) => {
        if (res.status == 200) {
          this.linkData.dataList = res.data.page.result
          this.linkData.totalCount = res.data.page.totalCount
        }
      })
    },
    // 翻页
    changePage(page) {
      this.getLinkList(page)
    },
    getBooks(val) {
      this.searchData = val
      this.getLinkList(1)
      this.$refs.LinksPublished.currentPageNo = 1
    }
  },
  watch: {
    booksCurrentSubAccount() {
      this.getLinkList(1)
    }
  },
  components: { ListHeader, LinksPublished }
}
</script>
<style lang="scss" scoped>
.my-books-container {
  width: 100%;
  height: 100%;
  padding-left: 18px;
}
</style>
